import { SortingHeaderButton } from '@/components/ui/DataTable/SortingHeaderButton'
import { RestSchemas } from '@/contexts/QueryProvider'
import { ColumnDef } from '@tanstack/react-table'
import clsx from 'clsx'
import { formatUsd } from '../formatUsd'
import { type TokenLimitOverrideRow } from '../TokenLimitOverrideRow'
import { RowActionsMenu } from './RowActionsMenu'

type OrganisationUser = RestSchemas['Messages.Subscriptions.OrganisationUser']

export function getTokenLimitOverrideColumns({
  canEdit,
  organisationUsers,
  existingOverrideUserIds,
}: {
  canEdit: boolean
  organisationUsers: OrganisationUser[]
  existingOverrideUserIds: number[]
}): ColumnDef<TokenLimitOverrideRow>[] {
  const columns: ColumnDef<TokenLimitOverrideRow>[] = [
    {
      id: 'name',
      accessorFn: (row) => clsx(row.givenName, row.familyName, row.email),
      header: ({ column }) => <SortingHeaderButton column={column}>User</SortingHeaderButton>,
      cell: ({ row }) => (
        <div className="flex flex-col gap-y-1">
          <span className="text-base">{clsx(row.original.givenName, row.original.familyName) || `User ${row.original.userId}`}</span>
          <span className="text-xs font-light leading-[1.1] text-muted-foreground">{row.original.email}</span>
        </div>
      ),
    },
    {
      id: 'limitUsd',
      accessorFn: (row) => row.limitUsd,
      header: ({ column }) => <SortingHeaderButton column={column}>Daily limit (USD)</SortingHeaderButton>,
      cell: ({ row }) => <span className="text-base">{formatUsd(row.original.limitUsd)}</span>,
    },
  ]

  if (canEdit) {
    columns.push({
      id: 'actions',
      cell: ({ row }) => (
        <div className="flex justify-end pr-5">
          <RowActionsMenu
            override={row.original}
            organisationUsers={organisationUsers}
            existingOverrideUserIds={existingOverrideUserIds}
          />
        </div>
      ),
    })
  }

  return columns
}
